import React from "react";
import { Navigate, useNavigate } from "react-router";
import homeArrow from "../../assests/icons/arrowhome.png";

function CardsItems({ ID, imageUrl, title , logo }) {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        navigate("/customizer?stage=" + ID, {state: logo});
      }}
    >
      <div className="my-3 flex flex-col items-center">
        {/* this is a carditem */}
        <div className="bg-white p-6 rounded-lg w-[280px] h-[280px] flex items-center cursor-pointer hover:border-2 border-[#000000]">
          <img src={imageUrl} alt="image" />
        </div>
        <h5
          className="mt-5 text-[16px]"
          style={{ fontFamily: "ZapfHumanistBold" }}
        >
          {title.toUpperCase()}
        </h5>
      </div>
    </div>
  );
}
export default CardsItems;
